<template>
  <el-dialog
    :visible.sync="localIsShowAddItemDialog"
    width="400px"
    center
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
  >
    <!-- タイトル -->
    <template>
      <div slot="title">
        <p>追加する自由項目の種類を選択してください</p>
      </div>
    </template>

    <!-- タイプ選択 -->
    <div class="flex center">
      <el-select v-model="type">
        <el-option
          v-for="item in computedTypeOptions"
          :key="`type-${item.value}`"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
    </div>

    <!-- アクション -->
    <div
      slot="footer"
      class="actions"
    >
      <el-button
        type="text"
        class="btn-text"
        @click="close"
      >
        キャンセル
      </el-button>
      <el-button
        type="text"
        class="btn-text"
        @click="addCustomFieldItem"
      >
        追加する
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
const TYPE_OPTIONS = [
  {
    value: "TEXT",
    label: "テキスト型",
  },
  {
    value: "TEXT_LIST",
    label: "テキストリスト型",
  },
  {
    value: "INT",
    label: "整数型",
  },
  {
    value: "FLOAT",
    label: "実数型",
  },
  {
    value: "DATE",
    label: "日付型",
  },
];

export default {
  name: "AdminOrderCustomFieldAddItemDialog",
  props: {
    isShowAddItemDialog: Boolean,
  },
  data () {
    return {
      type: "TEXT",
    };
  },
  computed: {
    localIsShowAddItemDialog: {
      get () {
        return this.isShowAddItemDialog;
      },
      set (value) {
        this.$emit("update:isShowAddItemDialog", value);
      },
    },
    computedTypeOptions () {
      return TYPE_OPTIONS;
    },
  },
  watch: {
  },
  created () {
  },
  methods: {
    /**
     * [addCustomField description]
     */
    addCustomFieldItem () {
      const { type } = this;

      this.$emit("addCustomFieldItem", type);
      this.close();
    },

    /**
     * [close description]
     */
    close () {
      this.$emit("closeAddItemDialog");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.actions {
  display: flex;
  padding: 10px 0;
}

::v-deep {
  .el-dialog__header {
    padding: 12px 15px;
  }

  .el-dialog__footer {
    padding: 12px 0 0;
  }
}
</style>
